import React from 'react'
import {
  CenterSide,
  DeskContainer,
  PairSeatingGroup,
  RightSide,
  ThirtySixSeatFloorPlan,
  TripleSeatDeskContainer,
  TripleSeatingGroup,
} from '../../styles/seatingChartStyles'
import { Desk } from './Desk'

export type ThirtySixSeatChartProps = {}

export const ThirtySixSeatChart = ({}: ThirtySixSeatChartProps) => {
  return (
    <ThirtySixSeatFloorPlan>
      <TripleSeatingGroup>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={1} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={2} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={3} />
          </TripleSeatDeskContainer>
        </CenterSide>
      </TripleSeatingGroup>

      <TripleSeatingGroup>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={4} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={5} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={6} />
          </TripleSeatDeskContainer>
        </CenterSide>
      </TripleSeatingGroup>

      <TripleSeatingGroup>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={7} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={8} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={9} />
          </TripleSeatDeskContainer>
        </CenterSide>
      </TripleSeatingGroup>

      <TripleSeatingGroup>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={10} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={11} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={12} />
          </TripleSeatDeskContainer>
        </CenterSide>
      </TripleSeatingGroup>

      <TripleSeatingGroup>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={13} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={14} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={15} />
          </TripleSeatDeskContainer>
        </CenterSide>
      </TripleSeatingGroup>

      <TripleSeatingGroup>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={16} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={17} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={18} />
          </TripleSeatDeskContainer>
        </CenterSide>
      </TripleSeatingGroup>

      <TripleSeatingGroup>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={19} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={20} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={21} />
          </TripleSeatDeskContainer>
        </CenterSide>
      </TripleSeatingGroup>

      <TripleSeatingGroup>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={22} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={23} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={24} />
          </TripleSeatDeskContainer>
        </CenterSide>
      </TripleSeatingGroup>

      <TripleSeatingGroup>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={25} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={26} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={27} />
          </TripleSeatDeskContainer>
        </CenterSide>
      </TripleSeatingGroup>

      <TripleSeatingGroup>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={28} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={29} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={30} />
          </TripleSeatDeskContainer>
        </CenterSide>
      </TripleSeatingGroup>

      <TripleSeatingGroup>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={31} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={32} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={33} />
          </TripleSeatDeskContainer>
        </CenterSide>
      </TripleSeatingGroup>

      <TripleSeatingGroup>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={34} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={35} />
          </TripleSeatDeskContainer>
        </CenterSide>
        <CenterSide>
          <TripleSeatDeskContainer>
            <Desk deskNumber={36} />
          </TripleSeatDeskContainer>
        </CenterSide>
      </TripleSeatingGroup>
    </ThirtySixSeatFloorPlan>
  )
}
